import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import { ProgressSpinner } from "primereact/progressspinner";

import { IssuanceServiceWBFx } from "./IssuanceServiceWBFx";
import { Satspertoken } from "../../App/Satspertoken";

// page for displaying chaertdata
const WBFxOperationAssets = ({ assets, transacted, setTransacted }) => {
  // initail value for chart data
  var issuanceservice = new IssuanceServiceWBFx();
  var satspertoken = new Satspertoken();
  const [loading, setLoading] = useState(1);

  const [data, setData] = useState();
  // {
  //   labels: ["Digital_$_Frank", "Digital_Euro"],
  //   datasets: [
  //     {
  //       data: [10000.0, 16000.0],
  //       backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
  //       hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
  //     },
  //   ],
  // }
  const [amount, setAmount] = useState([]);
  const [issuetype, setIssuetype] = useState([]);
  const intervalID = setInterval(
    myCallback,
    10000,
    "Parameter 1",
    "Parameter 2"
  );

  function myCallback(a, b) {
    // Your code here
    // Parameters are purely optional.
    console.log(a);
    console.log(b);
    setLoading(2);
  }

  useEffect(() => {
    if (amount.length > 0) {
      setLoading(2);
    } else {
      setLoading(1);
    }
  }, [amount]);

  useEffect(() => {
    setLoading(1);
    //fetch data from api
    const fetchData = async () => {
      const dataset1 = [];
      const dataset2 = [];
      /*
      await fetch(url)
        .then((data) => {
          console.log("api data", data);
          const res = data.json();
          return res;
        })
	    */
      issuanceservice
        .getsubscribebankbalance()
        .then((res) => {
          console.log("ress", res.balance);
          for (const val of res.balance) {
            dataset1.push(satspertoken.wrap(val.satspertoken, val.amount)); //val.amount);
            dataset2.push(val.issuetype);
          }
          setData({
            labels: dataset2,
            datasets: [
              {
                data: dataset1,
                backgroundColor: [
                  "#FFD700",
                  "#A38A00",
                  "#FFDE2E",
                  "#D1B000",
                  "#A38A00",
                ],
                hoverBackgroundColor: ["#FFE55C"],
              },
            ],
          });
          setAmount(dataset1);
          setIssuetype(dataset2);
          console.log("arrData", dataset1, dataset2);
          setTransacted({ ...transacted, operation: false });
        })
        .catch((e) => {
          console.log("error", e);
        });
    };
    fetchData();
  }, []);
  const [lightOptions] = useState({
    indexAxis: "x",
    elements: {
      doughnut: {
        borderWidth: 2,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#eee",
        },
      },
      title: {
        display: true,
        text: "OPERATION",
        color: "#eee",
      },
    },
  });

  // const dataset3 = [];

  // for (const val of data) {
  //   dataset3.push(val.amount);
  // }

  // console.log(dataset3);
  const value = amount.reduce((a, b) => a + b, 0);
  // console.log(value);
  const formatCurrency = (value) => {
    return value.toLocaleString("en-US");
  };

  return (
    <>
      <div className="col-12 ">
        <div className="grid p-fluid">
          <div className="col-12 md:col-6 ">
            <div className="card border-1 border-100 bg-gray-800  mt-3 card-w-title">
              <p className="border-bottom-1 pb-2 text-3xl">CBDC</p>
              <div className="list-disc">
                {issuetype.map((cdata, index) => (
                  <li className="text-2xl pb-2" key={index}>
                    {cdata}{" "}
                  </li>
                ))}
              </div>
              <p className=" text-2xl font-bold text-yellow-500">
                Total :{" "}
                <span className="text-3xl pb-2">{issuetype.length}</span>
              </p>
            </div>
          </div>
          <div className="col-12 md:col-6 ">
            <div className="card border-1 border-100 bg-gray-800  mt-3  card-w-title">
              <p className="border-bottom-1 pb-2 text-3xl">Assets</p>
              <div className="list-disc">
                {amount.map((cdata, index) => (
                  <li className="text-2xl pb-2" key={index}>
                    {formatCurrency(cdata)}{" "}
                  </li>
                ))}
              </div>
              <p className=" text-2xl font-bold text-yellow-500">
                Total : <span className="text-3xl pb-2">{amount.length}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="  flex flex-column align-items-center ">
        {loading == 1 ? (
          <div>
            <ProgressSpinner
              style={{ width: "80px", height: "80px" }}
              // strokeWidth="8"
              fill="var(--surface-ground)"
              animationDuration=".8s"
            />
          </div>
        ) : (
          ""
        )}

        <Chart
          type="doughnut"
          data={data}
          options={lightOptions}
          style={{
            position: "relative",
            width: "45%",
            justifyContent: "center",
          }}
        />
      </div>
    </>
  );
};

export default WBFxOperationAssets;
